import isEqual from "lodash/isEqual";
import type {
  DetailedUserProfileSerializer,
  IApiResponse,
  UserReviewSerializerV2,
  SingleQuoteSerializerWithArt,
  UserFolderSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const ugcApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getUserInfo: build.query<DetailedUserProfileSerializer, { userId: number }>(
      {
        query: ({ userId }) => ({
          url: `/foundation/api/users/${userId}`,
          params: {},
        }),

        transformResponse: (
          response: IApiResponse<DetailedUserProfileSerializer>
        ) => {
          return response.payload.data;
        },
        forceRefetch({ currentArg, previousArg }) {
          return !isEqual(currentArg, previousArg);
        },
      }
    ),
    getUserReviews: build.query<
      IApiResponse<UserReviewSerializerV2[]>["payload"],
      { userId: number; after?: string; limit?: number }
    >({
      query: ({ userId, after, limit }) => ({
        url: `/foundation/api/user/${userId}/reviews`,
        params: { limit, after },
      }),
      transformResponse: (response: IApiResponse<UserReviewSerializerV2[]>) => {
        return response.payload;
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newResponse, { arg }) => {
        if (arg.after) {
          currentCache.data.push(...newResponse.data);
        } else {
          currentCache.data = newResponse.data;
        }
        currentCache.pagination = newResponse.pagination;
      },

      forceRefetch({ currentArg, previousArg }) {
        return !isEqual(currentArg, previousArg);
      },
    }),
    getUserQuotes: build.query<
      IApiResponse<SingleQuoteSerializerWithArt[]>["payload"],
      { userId: number; limit?: number; offset?: number }
    >({
      query: ({ userId, limit, offset }) => ({
        url: `/foundation/api/users/${userId}/quotes`,
        params: {
          limit,
          offset,
        },
      }),
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}_${queryArgs.userId}`;
      },
      merge: (currentCacheData, responseData) => {
        return {
          ...responseData,
          data: [...currentCacheData.data, ...responseData.data],
        };
      },
      transformResponse: (
        response: IApiResponse<SingleQuoteSerializerWithArt[]>
      ) => {
        return response.payload;
      },
      forceRefetch({ currentArg, previousArg }) {
        return !isEqual(currentArg, previousArg);
      },
    }),
    getUserFolders: build.query<
      IApiResponse<UserFolderSerializer[]>["payload"],
      { userId: number; limit?: number; offset?: number }
    >({
      query: ({ userId, limit, offset }) => ({
        url: `/foundation/api/users/${userId}/folders`,
        params: {
          limit,
          offset,
        },
      }),
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}_${queryArgs.userId}`;
      },
      merge: (currentCacheData, responseData) => {
        return {
          ...responseData,
          data: [...currentCacheData.data, ...responseData.data],
        };
      },
      transformResponse: (response: IApiResponse<UserFolderSerializer[]>) => {
        return response.payload;
      },
      forceRefetch({ currentArg, previousArg }) {
        return !isEqual(currentArg, previousArg);
      },
    }),
  }),
});
